/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S4_P1_PostInputs */

const tr_kvkkbasvuru_s4_p1_post = /** @type {(inputs: Kvkkbasvuru_S4_P1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` içinde ücretsiz olarak sonuçlandırılır. İşlem ayrıca bir maliyet gerektirdiği takdirde Kişisel Verileri Koruma Kurulu'nca belirlenen tarifedeki ücret talep edilebilir.`)
};

const en_kvkkbasvuru_s4_p1_post = /** @type {(inputs: Kvkkbasvuru_S4_P1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. If the process additionally entails a cost, the fee in the tariff determined by the Kişisel Verileri Koruma Kurulu may be charged.`)
};

const de_kvkkbasvuru_s4_p1_post = /** @type {(inputs: Kvkkbasvuru_S4_P1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` kostenlos abgeschlossen. Erfordert der Vorgang zusätzlich Kosten, kann die Gebühr nach dem von der Kişisel Verileri Koruma Kurulu festgelegten Tarif verlangt werden.`)
};

const ru_kvkkbasvuru_s4_p1_post = /** @type {(inputs: Kvkkbasvuru_S4_P1_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Если исполнение дополнительно требует расходов, может быть взыскана плата по тарифу, установленному Kişisel Verileri Koruma Kurulu.`)
};

/**
* | output |
* | --- |
* | ". If the process additionally entails a cost, the fee in the tariff determined by the Kişisel Verileri Koruma Kurulu may be charged." |
*
* @param {Kvkkbasvuru_S4_P1_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s4_p1_post = /** @type {((inputs?: Kvkkbasvuru_S4_P1_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S4_P1_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s4_p1_post(inputs)
	if (locale === "de") return de_kvkkbasvuru_s4_p1_post(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s4_p1_post(inputs)
	return tr_kvkkbasvuru_s4_p1_post(inputs)
});